import { BaseUrl } from "./AdditionalApi";

export const PostUrlLore = `${BaseUrl}/api/lore/`

export default PostUrlLore